import { Injectable, inject } from "@angular/core";
import { Currency, CurrencyId } from "../models/currency";
import Decimal from "decimal.js";
import { currencyOptions } from "../constant/currency";
import { LoggerService } from "./logger.service";

@Injectable({
  providedIn: "root",
})
export class CurrencyService {
  private log = inject(LoggerService);


  public getCurrency(defaultValue: CurrencyId = "USD"): Currency {
    const [defaultCurrency, ...otherCurrencies] = this.getCurrencies(undefined, defaultValue);
    const cId = localStorage.getItem("currency");
    return otherCurrencies.find(({ id }) => id === cId) ?? defaultCurrency;
  }

  /**
   * DO not use this. Use the getCurrency() above.
   */
  public getCurrencies(currency?: CurrencyId, defaultValue: CurrencyId = "USD"): Array<Currency> {
    const exchangeRates = {
      USD: {
        rate: "1",
        locale: "en-US",
        symbol: "$",
      },
      EUR: {
        rate: "0.854043",
        locale: "de-DE",
        symbol: "€",
      },
      GBP: {
        rate: "0.762776",
        locale: "en-GB",
        symbol: "£",
      },
    };

    let matchingLocales = [];

    try {
      matchingLocales = Intl.NumberFormat.supportedLocalesOf([navigator.language]);
    } catch (e) {}

    const oldRate = new Decimal(exchangeRates[defaultValue].rate);

    if (defaultValue === "GBP") {
      this.log.info({ msg: "azure detected, currencies adjusted", old: exchangeRates });
      exchangeRates.USD.rate = new Decimal(exchangeRates.USD.rate).div(oldRate).toString();
      exchangeRates.EUR.rate = new Decimal(exchangeRates.EUR.rate).div(oldRate).toString();
      exchangeRates.GBP.rate = "1";
      this.log.info({ msg: "azure detected, currencies adjusted", new: exchangeRates });
    } else if (defaultValue === "EUR") {
      this.log.info({ msg: "drcc detected, currencies adjusted", old: exchangeRates });
      exchangeRates.USD.rate = new Decimal(exchangeRates.USD.rate).div(oldRate).toString();
      exchangeRates.GBP.rate = new Decimal(exchangeRates.GBP.rate).div(oldRate).toString();
      exchangeRates.EUR.rate = "1";
    }

    if (currency && exchangeRates[currency] !== undefined) {
      const filteredExchangeRate = exchangeRates[currency];
      const locale = matchingLocales.length > 0 ? matchingLocales[0] : filteredExchangeRate.locale;
      return [
        {
          exchangeRate: new Decimal(filteredExchangeRate.rate),
          id: currency,
          text: currency,
          symbol: filteredExchangeRate.symbol,
          locale: filteredExchangeRate.locale,
          format: new Intl.NumberFormat(locale, {
            ...currencyOptions,
            currency,
          }),
        },
      ];
    }
    return Object.entries(exchangeRates).map(([currency, { locale, rate, symbol }]) => {
      return {
        exchangeRate: new Decimal(rate),
        id: currency as CurrencyId,
        text: currency as CurrencyId,
        locale,
        symbol,
        format: new Intl.NumberFormat(matchingLocales.length > 0 ? matchingLocales[0] : locale, {
          ...currencyOptions,
          currency,
        }),
      };
    });
  }

  public formatCurrency(currency: Currency, value: number): string {
    const formattedValue = currency.format.format(
      currency.exchangeRate
        .mul(value || 0)
        .toDecimalPlaces(2)
        .toNumber(),
    );
    return formattedValue;
  }
}
